/**
 * AppBar Component
 * Main application header with navigation, user menu, and notifications
 */

import { AppBar as MuiAppBar, Toolbar, Box } from '@mui/material';
import { Logo } from './Logo';
import { NotificationBell } from './NotificationBell';
import { UserMenu } from './UserMenu';
import { WorkspaceSelector } from '@/features/workspaces/components/WorkspaceSelector';

export const AppBar: React.FC = () => {
  return (
    <MuiAppBar
      position="fixed"
      sx={{
        zIndex: (theme) => theme.zIndex.drawer + 1,
        bgcolor: 'background.default',
        height: { xs: 56, md: 64 },
        borderBottom: '0.25px solid #D2D7E5',
        boxShadow: 'none',
      }}
      elevation={0}
    >
      <Toolbar
        sx={{
          minHeight: { xs: 56, md: 64 },
          px: { xs: 2, md: 3 },
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        {/* Left Section: Logo */}
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Logo />
        </Box>

        {/* Right Section: Workspace + Notifications + User Menu */}
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <WorkspaceSelector />
          <NotificationBell />
          <UserMenu />
        </Box>
      </Toolbar>
    </MuiAppBar>
  );
};
